import React, { useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Form from 'react-bootstrap/Form';
import { LuSearch } from "react-icons/lu";
import './NavbarMain.css';

// French navmenu updated

const NavbarMain = (props) => {
  const [menu, setMenu] = useState([]);
  const [srch, setSrch] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [activeSubmenu, setActiveSubmenu] = useState(null);
  const handleDropdownMouseEnter = (key: string) => {
    setActiveDropdown(key);
    setActiveSubmenu(null);
  };
  const handleDropdownMouseLeave = () => {
    setActiveDropdown(null);
    setActiveSubmenu(null);
  };
  const handleSubmenuMouseEnter = (key: string) => {
    setActiveSubmenu(key);
  };


  useEffect(() => {
    const menu2 = {
      "248": {
        "title": "Contact",
        "link": "/contact-us/",
        "target": "",
        "menu_order": 18,
        "rel": "",
        "dropdown": {
          "23609": {
            "title": "Complaint Resolution Process",
            "link": "/complaint-resolution-process/",
            "target": "",
            "menu_order": 19,
            "rel": ""
          }
        }
      },
      "250": {
        "title": "Products",
        "link": "/products/",
        "target": "",
        "menu_order": 5,
        "rel": "",
        "dropdown": {
          "251": {
            "title": "Visitors to Canada Emergency Medical Insurance (VTC)",
            "link": "/products/visitors-canada-insurance/",
            "target": "",
            "menu_order": 6,
            "rel": ""
          },
          "252": {
            "title": "Travel Right Insurance Plans (TRIPS)",
            "link": "/products/trips/",
            "target": "",
            "menu_order": 7,
            "rel": "",
            "dropdown": {
              "253": {
                "title": "Travel",
                "link": "/products/trips/travel/",
                "target": "",
                "menu_order": 8,
                "rel": ""
              },
              "254": {
                "title": "Youth",
                "link": "/products/trips/youth/",
                "target": "",
                "menu_order": 9,
                "rel": ""
              }
            }
          },
          "255": {
            "title": "Student Accident Plan (SAP)",
            "link": "/products/student-accident-plan/",
            "target": "",
            "menu_order": 10,
            "rel": ""
          },
          "25723": {
            "title": "International Student Travel Insurance (ISP)",
            "link": "/products/international-student/",
            "target": "",
            "menu_order": 11,
            "rel": ""
          }
        }
      },
      "256": {
        "title": "Partners",
        "link": "/partner/",
        "target": "",
        "menu_order": 12,
        "rel": "",
        "dropdown": {
          "23890": {
            "title": "Online Training Sessions",
            "link": "/partner/online-training-sessions/",
            "target": "",
            "menu_order": 15,
            "rel": ""
          },
          "25803": {
            "title": "Partnership Request Form",
            "link": "/partner/form/",
            "target": "",
            "menu_order": 14,
            "rel": ""
          },
          "26027": {
            "title": "VTC Rate Calculator",
            "link": "https://quote.travelance.ca/#/VTC?language=en",
            "target": "_blank",
            "menu_order": 13,
            "rel": ""
          }
        }
      },
      "265": {
        "title": "Claims",
        "link": "/claims/",
        "target": "",
        "menu_order": 16,
        "rel": "",
        "dropdown": {
          "266": {
            "title": "Claims Submission and Forms",
            "link": "/claims/forms/",
            "target": "",
            "menu_order": 17,
            "rel": ""
          }
        }
      },
      "24947": {
        "title": "About",
        "link": "#",
        "target": "",
        "menu_order": 1,
        "rel": "",
        "dropdown": {
          "245": {
            "title": "About Us",
            "link": "/about-us/",
            "target": "",
            "menu_order": 2,
            "rel": ""
          },
          "246": {
            "title": "Mission & Vision",
            "link": "/about-us/mission-and-vision/",
            "target": "",
            "menu_order": 3,
            "rel": ""
          },
          "249": {
            "title": "Reviews",
            "link": "/contact-us/reviews/",
            "target": "",
            "menu_order": 4,
            "rel": ""
          }
        }
      },
      "21": {
        "title": "Blog",
        "link": "/blog/",
        "target": "",
        "menu_order": 19,
        "rel": ""
      },
    }
    const menu3 = {
      "247": {
        "title": "Produits",
        "link": "/produits/",
        "target": "",
        "menu_order": 5,
        "rel": "",
        "dropdown": {
          "22823": {
            "title": "Visiteurs au Canada Assurance médicale d’urgence",
            "link": "/produits/assurance-visiteurs-au-canada-frair-medicaux-durgence/",
            "target": "",
            "menu_order": 6,
            "rel": ""
          },
          "22824": {
            "title": "L’assurance voyage",
            "link": "/produits/l-assurance-voyage/",
            "target": "",
            "menu_order": 7,
            "rel": "",
            "dropdown": {
              "22840": {
                "title": "Voyage",
                "link": "/produits/l-assurance-voyage/voyage/",
                "target": "",
                "menu_order": 8,
                "rel": ""
              },
              "22839": {
                "title": "Jeunesse",
                "link": "/produits/l-assurance-voyage/jeunes/",
                "target": "",
                "menu_order": 9,
                "rel": ""
              }
            }
          },
          "22825": {
            "title": "Assurance Accident étudiant",
            "link": "/produits/regime-dassurance-accidents-pour-etudiants/",
            "target": "",
            "menu_order": 10,
            "rel": ""
          },
          "26248": {
            "title": "Police d’assurance voyage pour les étudiants étrangers",
            "link": "/produits/police-dassurance-voyage-pour-les-etudiants-etrangers/",
            "target": "",
            "menu_order": 11,
            "rel": ""
          }
        }
      },
      "22826": {
        "title": "Partenaires",
        "link": "/partenaires/",
        "target": "",
        "menu_order": 12,
        "rel": "",
        "dropdown": {
          "23027": {
            "title": "S'associer avec Travelance",
            "link": "/partenaires/sassocier-avec-travelance/",
            "target": "",
            "menu_order": 13,
            "rel": ""
          },
          "24170": {
            "title": "Formulaire de matériel de marketing",
            "link": "/partenaires/formulaire-de-materiel-de-marketing/",
            "target": "",
            "menu_order": 14,
            "rel": ""
          },
          "24171": {
            "title": "Sessions de formation en ligne",
            "link": "/partenaires/sessions-de-formation-en-ligne/",
            "target": "",
            "menu_order": 15,
            "rel": ""
          }
        }
      },
      "22828": {
        "title": "Réclamations",
        "link": "/reclamations/",
        "target": "",
        "menu_order": 16,
        "rel": "",
        "dropdown": {
          "22830": {
            "title": "Formulaires",
            "link": "/reclamations/formulaires/",
            "target": "",
            "menu_order": 17,
            "rel": ""
          }
        }
      },
      "22829": {
        "title": "Contactez-nous",
        "link": "/contactez-nous/",
        "target": "",
        "menu_order": 18,
        "rel": "",
        "dropdown": {
          "23607": {
            "title": "Processus de résolution des plaintes",
            "link": "/processus-de-resolution-des-plaintes/",
            "target": "",
            "menu_order": 19,
            "rel": ""
          }
        }
      },
      "27415": {
        "title": "À propos de nous",
        "link": "#",
        "target": "",
        "menu_order": 1,
        "rel": "",
        "dropdown": {
          "22833": {
            "title": "À propos de nous",
            "link": "/a-propos-de-nous/",
            "target": "",
            "menu_order": 2,
            "rel": ""
          },
          "22834": {
            "title": "Mission et vision",
            "link": "/a-propos-de-nous/mission-et-vision/",
            "target": "",
            "menu_order": 3,
            "rel": ""
          },
          "27416": {
            "title": "Reviews",
            "link": "/contactez-nous/avis",
            "target": "",
            "menu_order": 4,
            "rel": ""
          }
        }
      }
    }

    const menuData = props.lang === 'fr' ? menu3 : menu2;
    const sorted = Object.values(menuData).sort((a, b) => a.menu_order - b.menu_order);
    setMenu(sorted);
  },[props.lang]);

  const renderSubmenu = (submenu, parentKey) => {
    return submenu.map((item, idx) => {
      const key = item.title.toLowerCase().replace(/\W/g, '')
      if (item.dropdown) {
        const children = Object.values(item.dropdown).sort((a, b) => a.menu_order - b.menu_order);
        return (
          <NavDropdown key={key} rel={item.rel} target={item.target} className="subMenu" title={item.title} id={`${key}-dropdown`} href={item.link.replace('https://www.travelance.ca','')} show={activeSubmenu === key} onMouseEnter={() => handleSubmenuMouseEnter(key)}  renderMenuOnMount={true} onClick={(e) => redirectLink(e, item.link)}>
          {
            children.map((child, cid) => (
              <NavDropdown.Item key={`${key}-${cid}`} href={child.link.replace('https://www.travelance.ca','')} target={child.target} rel={child.rel}>
                {child.title}
              </NavDropdown.Item>
            )
          )}
          </NavDropdown>
        );
      } else {
        return (
          <NavDropdown.Item key={key} href={item.link.replace('https://www.travelance.ca','')} target={item.target} rel={item.rel}>
            {item.title}
          </NavDropdown.Item>
        );
      }
    });
  };

  var search = "Search";
  if(props.lang === 'fr'){
    search = "Recherche";
  }else{
    search = "Search";
  }

  function redirectLink(e: React.MouseEvent<HTMLElement>, href: string) {
    const target = e.target;
    if (target.classList.contains('dropdown-toggle')) {
      const navItem = (e.currentTarget).closest('.nav-item, .dropdown');
      if(navItem){
        e.preventDefault();
        e.stopPropagation();
        const targetHref = href;
        console.log(targetHref);
        if (!targetHref || targetHref === '#') return;

        if (window.innerWidth < 768) {
          const navWidth = document.querySelector('.navbar-nav')?.clientWidth || 0;
          const clickRatio = e.clientX / navWidth;

          if (clickRatio < 0.85) {
            window.location.href = targetHref;
          }
        } else {
          window.location.href = targetHref;
        }
      }
    }
  }

  return (
    <>
      <Navbar expand="lg" className="nav-justified">
        <Container>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <div className="cls-btn" onClick={() => document.querySelector('.navbar-toggler').click()} >X</div>
              <Row style={{width:"100%"}}>
                <Col sm={9}>
                  <Nav>
                  {
                    menu.map((item, i) => {
                      const key = item.title.toLowerCase().replace(/\W/g, '');
                      if (item.dropdown) {
                        const submenu = Object.values(item.dropdown).sort((a, b) => a.menu_order - b.menu_order);
                        return (
                          <NavDropdown key={key} rel={item.rel} target={item.target} data-test="1" title={item.title} id={`${key}-dropdown`} href={item.link.replace('https://www.travelance.ca','')} show={activeDropdown === key} onMouseEnter={() => handleDropdownMouseEnter(key)} onMouseLeave={handleDropdownMouseLeave} renderMenuOnMount={true} onClick={(e) => redirectLink(e, item.link)}>
                            {renderSubmenu(submenu, key)}
                          </NavDropdown>
                        );
                      }
                      return (
                        <Nav.Link key={key} href={item.link.replace('https://www.travelance.ca','')} rel={item.rel} target={item.target}>
                          {item.title}
                        </Nav.Link>
                      );
                    })
                  }
                  </Nav>
                </Col>
                <Col sm={3}>
                  <Form action="/search" method="GET" className="searchform" rel={{srch}} >
                    {
                      // eslint-disable-next-line
                      srch==1 ? <Form.Control type="search" placeholder={search} name="s" className="search" aria-label="Search" />:""
                    }
                    <LuSearch className="1" onClick={() => setSrch((prev) => !prev)} />
                  </Form>
                </Col>
              </Row>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </>
    );
}

export default NavbarMain;
